import { ActionDocumentType } from './action-document-type.enum';

export enum EngagementDocumentSource {
    AdminUpload = 0,
    Template = 1,
    BuyerUpload = 2,
}

export const EngagementDocumentSourceOptions = {
    [EngagementDocumentSource.AdminUpload]: 'Admin Upload',
    [EngagementDocumentSource.Template]: 'Template',
    [EngagementDocumentSource.BuyerUpload]: 'Buyer Upload',
};

export const EngagementDocumentSourceOptionsMapping = [
    {
        value: EngagementDocumentSource.AdminUpload,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.AdminUpload
        ],
        documentTypes: [
            ActionDocumentType.DocumentWithFeedback,
            ActionDocumentType.Downloadable,
            ActionDocumentType.Readonly,
        ],
    },
    {
        value: EngagementDocumentSource.Template,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.Template
        ],
        documentTypes: [ActionDocumentType.ForSign],
    },
    {
        value: EngagementDocumentSource.BuyerUpload,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.BuyerUpload
        ],
        documentTypes: [ActionDocumentType.IdNda],
    },
];
